(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gift-card-recipient-form"] && !Shopify.designMode) return;
  try {
    class RecipientForm extends HTMLElement {
    constructor() {
      super();
      this.emailInput = this.querySelector('[data-recipient-email]');
      this.confirmInput = this.querySelector('[data-recipient-email-confirm]');
      this.emailErrorEl = this.querySelector('[data-recipient-email-error]');
      this.confirmErrorEl = this.querySelector('[data-recipient-email-confirm-error]');
      this.form = this.closest('form');
    }

    connectedCallback() {
      if (!this.emailInput || !this.confirmInput || !this.form) return;

      this.onConfirmInput = this.onConfirmInput.bind(this);
      this.onEmailInput = this.onEmailInput.bind(this);
      this.onSubmit = this.onSubmit.bind(this);

      this.confirmInput.addEventListener('input', this.onConfirmInput);
      this.emailInput.addEventListener('input', this.onEmailInput);
      this.form.addEventListener('submit', this.onSubmit, true);
    }

    disconnectedCallback() {
      if (!this.form) return;
      this.confirmInput.removeEventListener('input', this.onConfirmInput);
      this.emailInput.removeEventListener('input', this.onEmailInput);
      this.form.removeEventListener('submit', this.onSubmit, true);
    }

    emailsMatch() {
      const a = (this.emailInput.value || '').trim().toLowerCase();
      const b = (this.confirmInput.value || '').trim().toLowerCase();
      return a === b;
    }

    setFieldError(input, errorEl, message) {
      if (message) {
        input.setAttribute('aria-invalid', 'true');
        input.setCustomValidity(message);
        if (errorEl) {
          errorEl.textContent = message;
          errorEl.removeAttribute('hidden');
        }
      } else {
        input.removeAttribute('aria-invalid');
        input.setCustomValidity('');
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.setAttribute('hidden', '');
        }
      }
    }

    setMismatchState(isMismatch) {
      const message = isMismatch
        ? (this.confirmErrorEl && this.confirmErrorEl.dataset.msgMismatch) || 'Emails do not match'
        : '';
      this.setFieldError(this.confirmInput, this.confirmErrorEl, message);
    }

    onConfirmInput() {
      if (!this.confirmInput.value) {
        this.setMismatchState(false);
        return;
      }
      this.setMismatchState(!this.emailsMatch());
    }

    onEmailInput() {
      if (this.emailInput.value.trim()) {
        this.setFieldError(this.emailInput, this.emailErrorEl, '');
      }
      if (!this.confirmInput.value) return;
      this.setMismatchState(!this.emailsMatch());
    }

    onSubmit(event) {
      const emailEmpty = !this.emailInput.value.trim();
      const confirmEmpty = !this.confirmInput.value.trim();
      let firstInvalid = null;

      if (emailEmpty) {
        const msg = (this.emailErrorEl && this.emailErrorEl.dataset.msgRequired) || 'This field is required';
        this.setFieldError(this.emailInput, this.emailErrorEl, msg);
        firstInvalid = this.emailInput;
      } else {
        this.setFieldError(this.emailInput, this.emailErrorEl, '');
      }

      if (confirmEmpty) {
        const msg = (this.confirmErrorEl && this.confirmErrorEl.dataset.msgRequired) || 'This field is required';
        this.setFieldError(this.confirmInput, this.confirmErrorEl, msg);
        firstInvalid = firstInvalid || this.confirmInput;
      } else if (!emailEmpty && !this.emailsMatch()) {
        this.setMismatchState(true);
        firstInvalid = firstInvalid || this.confirmInput;
      } else if (!emailEmpty) {
        this.setMismatchState(false);
      }

      if (firstInvalid) {
        event.preventDefault();
        event.stopImmediatePropagation();
        firstInvalid.focus();
      }
    }
  }

  if (!customElements.get('recipient-form')) {
    customElements.define('recipient-form', RecipientForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product-blocks"] && !Shopify.designMode) return;
  try {
    /* Update Collapsible tab SKU when variant changes */
  (function () {
    if (window.__pdpSkuListenerAttached) return;
    window.__pdpSkuListenerAttached = true;

    document.addEventListener('variant:changed', function (event) {
      var variant = event.detail || {};
      var sku = variant.sku || '';
      var nodes = document.querySelectorAll('[data-pdp-sku]');
      nodes.forEach(function (node) {
        var valueEl = node.querySelector('[data-pdp-sku-value]');
        if (valueEl) valueEl.textContent = sku;
        if (sku) {
          node.removeAttribute('hidden');
        } else {
          node.setAttribute('hidden', '');
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
